import { combineReducers } from 'redux'
import ping from './ping'
import configuration, * as fromConfiguration from './configuration'

export default combineReducers({
  configuration,
  ping
})

export const getTitle = state => fromConfiguration.getTitle(state.configuration)
export const getContent = state => fromConfiguration.getContent(state.configuration)



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/